import { render, staticRenderFns } from "./cart.vue?vue&type=template&id=52c33f4b&scoped=true"
import script from "./cart.vue?vue&type=script&lang=js"
export * from "./cart.vue?vue&type=script&lang=js"
import style0 from "./cart.vue?vue&type=style&index=0&id=52c33f4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c33f4b",
  null
  
)

export default component.exports